import React from 'react';
import { Card, Header1Text, Breadcrumbs } from 'ui-toolkit';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';

interface ILenderDetailsHeaderProps {
  companyName: string;
  lenderId: string;
}

export const LenderDetailsHeader: React.FC<ILenderDetailsHeaderProps> = ({ companyName, lenderId }) => (
  <>
    <Breadcrumbs
      homeLink={ClientUrlFactory().urlFor.adminOrders()}
      links={[
        {
          to: ClientUrlFactory().urlFor.lendersIndex(),
          text: 'Lenders',
        },
        {
          to: ClientUrlFactory().urlFor.lenderCompany(lenderId),
          text: companyName,
        },
      ]}
    />
    <Card>
      <Header1Text>{companyName}</Header1Text>
    </Card>
  </>
);
